export const isOpportunityNew = (createdAt: string, lastVisitedAt: Date | null): boolean =>
  lastVisitedAt == null || new Date(createdAt) > lastVisitedAt;
